export default {
  namespaced: true,

  state: {
    synced: null
  },

  mutations: {
    synced(state, synced) {
      state.synced = synced;
    }
  },

  actions: {
    async synced({ commit, dispatch }) {
      return dispatch("ajax", {
        url: "/v1/address/synced"
      }, { root: true }).then(res => {
        commit("synced", res.synced);
        return res;
      });
    }
  }
};
